/* eslint-disable react/prop-types */
import React, { useState, useEffect, useCallback, Fragment } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import { Grid, Typography, Button } from "@mui/material";
import Divider from "@mui/material/Divider";
import ControlledDialog from "../../../../../components/ControlledDialog/ControlledDialog";
import LoginMenu from "../../../../../components/LoginMenu/LoginMenu";
import mc from "../../../../../assets/Images/mastervisacard.jpeg";
import PayViaBankTransfer from "../../HelperChunks/PayViaBankTransfer";
import AnnouncementDialog from "../../../../../components/AnnouncementDialog/AnnouncementDialog";
import AnnouncmentBackgroundIcon from "../../../../../assets/Images/megaphoneIcon.png";
import Alert from '@mui/material/Alert';
import CustomizedSnackbar from "../../../../../components/CustomizedSnackbar/CustomizedSnackbar";

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    margin: 10,
    padding: 10,
  },
  blockStyle: {
    paddingLeft: 10,
    paddingTop: 10,
    paddingBottom: 10,
    textAlign: "left",
    border: "1px solid rgb(211, 211, 211)",
    borderRadius: 5,
  },
}));

const TutionFeePayment = (props) => {
  const { success } = props;
  const classes = useStyles();

  const [isOpenSnackbar, setIsOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("");
  const [payment_term, setPayment_term] = useState(false);
  const [payment_term_val, setPayment_term_val] = useState("");
  const [payment_term_error, setPayment_term_error] = useState("");
  const [studentId, setStudentId] = useState("");
  const [id, setId] = useState("");
  const [voucher_no, setVoucher_no] = useState("");
  const [created_on, setCreated_on] = useState("");
  const [due_date, setDue_date] = useState("");
  const [amount, setAmount] = useState("");
  const [afterDueDate, setAfterDueDate] = useState("");
  const [status_id, setStatus_id] = useState("");
  const [status_label, setStatus_label] = useState("");
  const [status_changed_on, setStatus_changed_on] = useState("");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isLoginMenu, setIsLoginMenu] = useState(false);
  const [isReload, setIsReload] = useState(false);
  const [isBankOpen, setIsBankOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({
    paymentDate: null,
    referenceNo: "",
    files: [],
  });
  const [formErrors, setFormErrors] = useState({
    paymentDate: "",
    referenceNoError: "",
    filesError: "",
  });
  const [refCheck, setRefCheck] = useState(false);
  const [vocherData, setVocherData] = useState({});
  const [uploadData, setUploadData] = useState([]);
  const [feeAnouncementData, setFeeAnouncementData] = useState("");
  const [feeAnouncementOpen, setFeeAnouncementOpen] = useState(false);
  const [feeAnouncementLabel, setFeeAnouncementLabel] = useState("");
  const [feeAnouncementDate, setFeeAnouncementDate] = useState("");
  const [feeAnouncementDetails, setFeeAnouncementDetails] = useState("");
  const [feePaidAnouncementOpen, setFeePaidAnouncementOpen] = useState(false);

  const handleOpenSnackbar = useCallback((msg, severity) => {
    setIsOpenSnackbar(true);
    setSnackbarMessage(msg);
    setSnackbarSeverity(severity);
  }, []);

  const handleCloseSnackbar = useCallback((event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setIsOpenSnackbar(false);
  }, []);

  const payment_term_handler = useCallback((event) => {
    setPayment_term_val(event.target.value);
  }, []);

  const LoadData = useCallback(async () => {
    let url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C116FinanceStudentsLegacyFeeVoucherView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then((json) => {
        if (json.CODE === 1) {
          if (json.DATA) {
            if (json.DATA.length > 0) {
              setId(json.DATA[0].id);
              setStudentId(json.DATA[0].studentId);
              setVoucher_no(json.DATA[0].voucherNo);
              setCreated_on(json.DATA[0].createdOn);
              setDue_date(json.DATA[0].dueDate);
              setAmount(json.DATA[0].totalAmount);
              setAfterDueDate(json.DATA[0].totalAmountAfterDueDate);
              setStatus_id(json.DATA[0].statusId);
              setStatus_label(json.DATA[0].statusLabel);
              setStatus_changed_on(json.DATA[0].statusChangedOn);
              setVocherData(json.DATA[0]);
              setUploadData(json.DATA);
            }
          }
        } else {
          handleOpenSnackbar(
            <span>
              {json.SYSTEM_MESSAGE}
              <br />
              {json.USER_MESSAGE}
            </span>,
            "error"
          );
        }
        console.log(json);
      })
      .catch((error) => {
        if (error.status == 401) {
          setIsLoginMenu(false);
          setIsReload(true);
        } else {
          handleOpenSnackbar(
            <span>Operation Failed, Please try again later.</span>,
            "error"
          );
          console.log(error);
        }
      });
  }, [handleOpenSnackbar]);

  const handleFeeAnnouncmentDialog = useCallback(() => {
    const { feeDueDateStatus = 0, deactiveMessage = "" } =
      window.localStorage.getItem("lmsData")
        ? JSON.parse(window.localStorage.getItem("lmsData"))
        : {};
    setFeeAnouncementDate("");
    setFeeAnouncementDetails(deactiveMessage);
    setFeeAnouncementLabel("Fee Submission Notice");
    setFeeAnouncementOpen(true);
  }, []);

  const onFeeAnnouncementClose = useCallback(() => {
    sessionStorage.setItem("lmsFeeAnnouncementReadFlag", 1);
    setFeeAnouncementOpen(false);
    setFeeAnouncementDetails("");
    setFeeAnouncementDate("");
    setFeeAnouncementLabel("");
  }, []);

  const loadingData = useCallback(async () => {
    setIsLoading(true);
    await LoadData();
    setIsLoading(false);
  }, [LoadData]);

  const handleBankToggle = useCallback(() => {
    setIsBankOpen(prev => !prev);
  }, []);

  const onRefCheckChnage = useCallback((e) => {
    const { checked } = e.target;
    setRefCheck(checked);
    setForm(prev => ({ ...prev, referenceNo: "" }));
    setFormErrors(prev => ({ ...prev, referenceNoError: "" }));
  }, []);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    setFormErrors(prev => ({ ...prev, [`${name}Error`]: "" }));
  }, []);

  const handleFileChange = useCallback((event) => {
    const { files = [] } = event.target;
    setForm(prev => ({ ...prev, files }));
    setFormErrors(prev => ({ ...prev, filesError: "" }));
  }, []);

  const handleDateChange = useCallback((date) => {
    console.log(date);
    setForm(prev => ({ ...prev, paymentDate: date }));
    setFormErrors(prev => ({ ...prev, paymentDate: "" }));
  }, []);

  const isFormValid = useCallback(() => {
    let isValid = true;
    const errors = { ...formErrors };

    if (!form.referenceNo && !refCheck) {
      errors.referenceNoError = "Please provide Transaction Id";
      isValid = false;
    }
    if (!form.paymentDate) {
      errors.paymentDate = "Please provide payment date";
      isValid = false;
    }

    if (form.files.length <= 0) {
      errors.filesError = "Please select a file.";
      isValid = false;
    }

    setFormErrors(errors);

    return isValid;
  }, [form, formErrors, refCheck]);

  const handleSubmitButtonClick = useCallback(() => {
    const isValid = isFormValid();
    if (isValid) {
      document.getElementById("submit-button").click();
    }
    return;
  }, [isFormValid]);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    const data = new FormData(e.target);

    setIsLoading(true);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C116FinanceStudentsLegacyFeeVouchersStudentUpload`;
    console.log(url);
    await fetch(url, {
      method: "POST",
      body: data,
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then((result) => {
        if (result.CODE == 1) {
          alert("File uploaded, thank you");
          window.localStorage.setItem("isTuitionFeeChallanUploaded", 1);
          loadingData();
          handleBankToggle();
        } else if (result.CODE == 2) {
          alert(result.CODE + ":" + result.USER_MESSAGE);
        } else if (result.CODE == 3) {
          alert(result.CODE + ":" + result.SYSTEM_MESSAGE);
        } else if (result.error == 1) {
          alert(result.error_message);
        }
      })
      .catch((error) => {
        if (error.status == 401) {
          setIsLoginMenu(true);
          setIsReload(false);
        } else {
          alert("Operation Failed, Please try again later.");
          console.log(error);
        }
      });
    setIsLoading(false);
  }, [loadingData, handleBankToggle]);

  const DownloadFile = useCallback((fileName) => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${
      process.env.REACT_APP_SUB_API_NAME
    }/common/CommonViewFile?fileName=${encodeURIComponent(fileName)}`;
    fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (res.status === 200) {
          return res.blob();
        } else if (res.status === 401) {
          setIsLoginMenu(true);
          setIsReload(false);
          return {};
        } else {
          handleOpenSnackbar(
            <span>Operation Failed, Please try again later.</span>,
            "error"
          );
          return {};
        }
      })
      .then((result) => {
        var csvURL = window.URL.createObjectURL(result);
        var tempLink = document.createElement("a");
        tempLink.href = csvURL;
        tempLink.setAttribute("download", fileName);
        tempLink.click();
        console.log(csvURL);
        if (result.CODE === 1) {
          //Code
        } else if (result.CODE === 2) {
          alert(
            "SQL Error (" +
              result.CODE +
              "): " +
              result.USER_MESSAGE +
              "\n" +
              result.SYSTEM_MESSAGE
          );
        } else if (result.CODE === 3) {
          alert(
            "Other Error (" +
              result.CODE +
              "): " +
              result.USER_MESSAGE +
              "\n" +
              result.SYSTEM_MESSAGE
          );
        } else if (result.error === 1) {
          alert(result.error_message);
        } else if (result.success === 0 && result.redirect_url !== "") {
          window.location = result.redirect_url;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [handleOpenSnackbar]);

  const onLogout = useCallback(() => {
    window.localStorage.removeItem("lmsData");
    window.localStorage.removeItem("lmsToken");
    window.localStorage.removeItem("lmsStudentId");
    window.localStorage.removeItem("lmsMeetingConfig");
    window.location.replace("#/login");
  }, []);

  useEffect(() => {
    let checkIsFeePaid = `${window.location}`.includes(
      "qJqkBXkjw+VsqXTLD6pDEQWYJga+JsYWyyRgAwjebng="
    );
    if (checkIsFeePaid) {
      setFeePaidAnouncementOpen(true);
      return;
    }
    const { feeDueDateStatus = 0 } = window.localStorage.getItem("lmsData")
      ? JSON.parse(window.localStorage.getItem("lmsData"))
      : {};
    console.log(feeDueDateStatus);
    if (
      feeDueDateStatus === 3 &&
      sessionStorage.getItem("lmsFeeAnnouncementReadFlag") != 1
    ) {
      handleFeeAnnouncmentDialog();
      console.log("data");
    }
    loadingData();
    setIsDialogOpen(success);
  }, [success, loadingData, handleFeeAnnouncmentDialog]);

  const isChallanUploaded = localStorage.getItem(
    "isTuitionFeeChallanUploaded"
  );

  return (
    <Fragment>
      <LoginMenu
        reload={isReload}
        open={isLoginMenu}
        handleClose={() => setIsLoginMenu(false)}
      />
      <AnnouncementDialog
        handleClose={() => onLogout()}
        dividers
        open={feePaidAnouncementOpen}
        titleStyle={{ backgroundColor: "#388e3c" }}
        title="Notification"
        content={
          <Fragment>
            <span style={{ float: "right" }}>
              <span style={{ color: "grey", float: "right", fontSize: 14 }}>
                {feeAnouncementDate}
              </span>
              <br />
              <img
                src={AnnouncmentBackgroundIcon}
                style={{
                  height: 80,
                  paddingRight: 12,
                  float: "right",
                  marginTop: 7,
                }}
              />
            </span>
            <span>
              <Typography color="primary" component="span" variant="h5">
                Fee Submission Notice
              </Typography>
              <br />
              <br />
              <Typography variant="body1" component="span">
                &emsp;Payment Successful. Please login again.
              </Typography>
            </span>
          </Fragment>
        }
        actions={
          <Button color="secondary" onClick={() => onLogout()}>
            Close
          </Button>
        }
      />
      <AnnouncementDialog
        handleClose={() => onFeeAnnouncementClose()}
        dividers
        open={feeAnouncementOpen}
        titleStyle={{ backgroundColor: "#b22c2c" }}
        title="Notification"
        content={
          <Fragment>
            <span style={{ float: "right" }}>
              <span style={{ color: "grey", float: "right", fontSize: 14 }}>
                {feeAnouncementDate}
              </span>
              <br />
              <img
                src={AnnouncmentBackgroundIcon}
                style={{
                  height: 80,
                  paddingRight: 12,
                  float: "right",
                  marginTop: 7,
                }}
              />
            </span>
            <span>
              <Typography color="primary" component="span" variant="h5">
                {feeAnouncementLabel}
              </Typography>
              <br />
              <Typography variant="body1" component="span">
                &emsp;{feeAnouncementDetails}
              </Typography>
            </span>
          </Fragment>
        }
        actions={
          <Button
            color="primary"
            onClick={() => onFeeAnnouncementClose()}
          >
            Pay Now
          </Button>
        }
      />
      {isBankOpen && (
        <PayViaBankTransfer
          type={1}
          handleClose={() => handleBankToggle()}
          onRefCheckChnage={(e) => onRefCheckChnage(e)}
          handleChange={(e) => handleChange(e)}
          handleFileChange={(e) => handleFileChange(e)}
          handleDateChange={(date) => handleDateChange(date)}
          downloadFile={(name) => DownloadFile(name)}
          values={{ form, formErrors, refCheck, vocherData, uploadData, isLoading }}
          handleSubmit={(e) => handleSubmit(e)}
          handleSubmitButtonClick={() => handleSubmitButtonClick()}
        />
      )}
      {!isBankOpen && (
        <Fragment>
          <ControlledDialog
            open={isDialogOpen}
            handleClose={() => setIsDialogOpen(false)}
            title="Success"
            content="Your fee has been paid. Thank you for applying to UCL. Our admissions team will get in touch with you soon."
          />
            <div className={classes.root}>
              <Typography
                style={{
                  color: "#1d5f98",
                  fontWeight: 600,
                  fontSize: 20,
                }}
                variant="h5"
              >
                Tuition Fee Payment
              </Typography>
              <Divider
                style={{
                  backgroundColor: "rgb(58, 127, 187)",
                  opacity: "0.3",
                }}
              />
              {isChallanUploaded == 1 && (
                <Alert style={{ marginTop: 10 }}>
                  Dear Applicant, Thank you for uploading the Fee Payment
                  Evidence. Our admission team will verify it and email you
                  regarding your payment status soon.
                </Alert>
              )}
              <div
                style={{
                  marginTop: "25px",
                  marginBottom: "60px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <form
                  id="myform"
                  onSubmit={handleSubmit}
                  autoComplete="off"
                >
                  <input type="hidden" name="id" value={1400}></input>
                  <input type="hidden" name="createdBy" value={123}></input>
                  <input type="hidden" name="isActive" value={1}></input>
                  <Grid direction="row" container spacing={1}>
                    <Grid item xs={1} align="left"></Grid>

                    <Grid size={{ xs: 12, sm: 12 }}>
                      <table
                        style={{
                          width: "100%",
                          borderColor: "",
                          borderRadius: "5px",
                        }}
                      >
                        <thead>
                          <tr>
                            <th className={classes.blockStyle}>
                              <Typography
                                color="primary"
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                Nucleus Id
                              </Typography>
                            </th>
                            <td
                              className={classes.blockStyle}
                              style={{
                                paddingRight: "350px",
                              }}
                            >
                              {studentId || "--"}
                            </td>
                          </tr>
                          <tr>
                            <th className={classes.blockStyle}>
                              <Typography
                                color="primary"
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                Voucher No
                              </Typography>
                            </th>
                            <td
                              className={classes.blockStyle}
                              style={{
                                paddingRight: "350px",
                              }}
                            >
                              {voucher_no || "--"}
                            </td>
                          </tr>
                          <tr>
                            <th className={classes.blockStyle}>
                              <Typography
                                color="primary"
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                Created On
                              </Typography>
                            </th>
                            <td
                              className={classes.blockStyle}
                              style={{
                                paddingRight: "350px",
                              }}
                            >
                              {created_on || "--"}
                            </td>
                          </tr>
                          <tr>
                            <th className={classes.blockStyle}>
                              <Typography
                                color="primary"
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                Due Date
                              </Typography>
                            </th>
                            <td
                              className={classes.blockStyle}
                              style={{
                                paddingRight: "350px",
                              }}
                            >
                              {due_date || "--"}
                            </td>
                          </tr>
                          <tr>
                            <th className={classes.blockStyle}>
                              <Typography
                                color="primary"
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                Amount
                              </Typography>
                            </th>
                            <td
                              className={classes.blockStyle}
                              style={{
                                paddingRight: "350px",
                              }}
                            >
                              {amount || "--"}
                            </td>
                          </tr>
                          <tr>
                            <th className={classes.blockStyle}>
                              <Typography
                                color="primary"
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                Payable After Due Date
                              </Typography>
                            </th>
                            <td
                              className={classes.blockStyle}
                              style={{
                                paddingRight: "350px",
                              }}
                            >
                              {afterDueDate || "--"}
                            </td>
                          </tr>
                          <tr>
                            <th className={classes.blockStyle}>
                              <Typography
                                color="primary"
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                Status
                              </Typography>
                            </th>
                            {vocherData.isConfirmed === 1 ? (
                              <td
                                className={classes.blockStyle}
                                style={{
                                  paddingRight: "350px",
                                  color: "#FCF6F5FF",
                                  backgroundColor: "#2BAE66FF",
                                }}
                              >
                                {status_label || "--"}
                              </td>
                            ) : (
                              <td
                                className={classes.blockStyle}
                                style={{
                                  paddingRight: "350px",
                                }}
                              >
                                {status_label || "--"}
                              </td>
                            )}
                          </tr>
                          <tr>
                            <th className={classes.blockStyle}>
                              <Typography
                                color="primary"
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                Status Changed On
                              </Typography>
                            </th>
                            <td
                              className={classes.blockStyle}
                              style={{
                                paddingRight: "450px",
                              }}
                            >
                              {status_changed_on || "--"}
                            </td>
                          </tr>
                        </thead>
                      </table>
                    </Grid>
                  </Grid>
                </form>
              </div>
              {vocherData.isConfirmed == 0 && (
                <Fragment>
                  <Alert severity="info" style={{ marginTop: 10, marginBottom: 15 }}>
                    <Typography variant="body2">
                      <strong>Note:</strong> 2% bank charges will be applied if you pay via Debit/Credit Card.
                    </Typography>
                  </Alert>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "10px",
                      marginRight: "15px",
                    }}
                  >
                    <img src={mc} width={100} height={45} alt={"1"}></img>
                    <Button
                      variant="contained"
                      color="inherit"
                      style={{
                        marginLeft: "10px",
                        textTransform: "none",
                      }}
                      onClick={() =>
                        (window.location = `${process.env.REACT_APP_API_FEE_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/TutionFeePaymentAutoV3.html`)
                      }
                    >
                      Pay via Debit / Credit Card
                    </Button>
                  <Button
                    variant="contained"
                    color=""
                    onClick={() => handleBankToggle()}
                    style={{
                      marginLeft: "10px",
                      textTransform: "none",
                    }}
                  >
                    Pay via Bank Transfer
                  </Button>
                  <Button
                    variant="contained"
                    color=""
                    onClick={() => window.open(`#/challan-view`, "_blank")}
                    style={{
                      marginLeft: "10px",
                      textTransform: "none",
                      marginRight: "-10px",
                      width: 170,
                    }}
                  >
                    Pay via Fee Challan
                  </Button>
                </div>
                </Fragment>
              )}
            <CustomizedSnackbar
              isOpen={isOpenSnackbar}
              message={snackbarMessage}
              severity={snackbarSeverity}
              handleCloseSnackbar={() => handleCloseSnackbar()}
            />
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

TutionFeePayment.propTypes = {
  success: PropTypes.bool,
};

TutionFeePayment.defaultProps = {
  success: false,
};

export default TutionFeePayment;
